import React, { Fragment, memo } from 'react';
import { createGlobalStyle } from 'styled-components';
import { white, dividerGrayLight } from '../../design-system/variables/colors';
import { spaceBig, spaceLarge, spaceBase, spaceMedium, spaceTiny } from '../../design-system/variables/spaces';
import { Icon } from '../Icon';
import { SocialMedia } from './SocialMedia';
import { Paragraph } from '../Paragraph';
import { lg, md, sm, smOnly } from '../../design-system/media-queries';

const GlobalStyle = createGlobalStyle`
	.sub-footer__container {
		margin: 0 auto;
		padding-left: ${spaceBase};
		padding-right: ${spaceBase};
		padding-bottom: ${spaceBig};
		padding-top: ${spaceLarge};
		width: 100%;
		max-width: 1200px;

		${sm`
			padding-left: ${spaceLarge};
			padding-right: ${spaceLarge};
			border-top: ${dividerGrayLight};
		`}
		${smOnly`
			padding-top: ${spaceBig};
		`}

		p {
			margin: ${spaceMedium} 0 0;

			${md`
				margin-top: 0;
			`}
		}
	}

	.sub-footer__gap {
		${md`
			gap: ${spaceLarge};
			padding-left: ${spaceBase};
			padding-right: ${spaceBase};
		`}

		${lg`
			gap: ${spaceBig};
			padding-left: 0;
			padding-right: 0;
		`}
	}

	.sub-footer__link {
		display: inline-block;
		fill: ${white};
		line-height: 0;

		svg {
			width: 100%;
		}

		.ispo-logo {
			max-width: 77px;
			border-top: ${dividerGrayLight};
    		padding-top: ${spaceMedium};

			${md`
				border-top: none;
				padding-top: initial;
			`}
		}

		.right-logo {
			height: 44px;
			max-width: 228px;
			margin-bottom: ${spaceTiny};

			${md`
				height: 34px;
				max-width: 160px;
				margin-bottom: initial;
			`}
		}
	}

	.sub-footer__phone-link {
		&:hover {
			text-decoration: none;
		}
	}
`;

export const Subfooter: React.FC = memo(() => {
	const currentYear = new Date(Date.now()).getFullYear();

	return (
		<Fragment>
			<GlobalStyle />
			<section className='sub-footer__container'>
				<div className='row middle-xs center-xs'>
					<SocialMedia />
				</div>
				<div className='row center-xs between-md sub-footer__gap'>
					<div className='col-xs-12 col-md center-xs end-lg'></div>
					<div className='col-xs-11 col-sm-7 center-xs'>
						<Paragraph size='small'>
							Inspirato&reg; is owned by Inspirato&nbsp;LLC. All&nbsp;products and services offered
							by&nbsp;Inspirato&reg; are provided solely by Inspirato&nbsp;LLC or its agents
							and&nbsp;affiliates. &copy;&nbsp;Copyright&nbsp;{currentYear} Inspirato&nbsp;LLC.
							All&nbsp;rights reserved.&nbsp;
							<a className='sub-footer__phone-link' href='tel:(303) 586-7771'>
								(303)&nbsp;586&#8209;7771
							</a>
						</Paragraph>
					</div>
					<div className='col-xs-12 col-md center-xs first-xs last-md'>
						<a className='sub-footer__link' color='white' href='/' title='Go to the Inspirato Home Page'>
							<Icon iconName='logo-inspirato' className='right-logo' />
						</a>
					</div>
				</div>
			</section>
		</Fragment>
	);
});
